import { createListenerMiddleware } from '@reduxjs/toolkit';
import {
  constant,
  createListenerEffect,
  ENVIRONMENT,
  selectLogRocketId,
  selectLogRocketName,
  selectVersion,
} from '@socialive/common';
import LogRocket from 'logrocket';
import setupLogRocketReact from 'logrocket-react';

export const effect = createListenerEffect(
  'initLogRocket<Listener>',
  async (action, { dispatch, getState, unsubscribe, trigger }) => {
    unsubscribe();

    const logRocketId = selectLogRocketId(getState());
    const logRocketName = selectLogRocketName(getState());
    const release = selectVersion(getState());
    const localHost = window.CONFIG.environment === ENVIRONMENT.LOCAL;

    if (!localHost) {
      LogRocket.init(`${logRocketId}/${logRocketName}`, {
        release,
        network: {
          requestSanitizer: (request) => {
            if (request.headers.authorization) {
              request.headers.authorization = '';
            }

            const filterRequestBodies = ['auth/login', 'password/update-from-token', 'user'];
            const requestUrl = request.url.toLowerCase();

            if (filterRequestBodies.some((filter) => requestUrl.includes(filter))) {
              request.body = null;
            }

            return request;
          },
        },
      });
      setupLogRocketReact(LogRocket);
    }
  }
);

const { startListening, middleware } = createListenerMiddleware();

startListening({
  matcher: constant(true),
  effect,
});

export default middleware;
